import { render } from "./AdminBookingView.vue?vue&type=template&id=24e9354a&scoped=true"
import script from "./AdminBookingView.vue?vue&type=script&lang=js"
export * from "./AdminBookingView.vue?vue&type=script&lang=js"

import "./AdminBookingView.vue?vue&type=style&index=0&id=24e9354a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24e9354a"]])

export default __exports__